import styled, { css, DefaultTheme } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

const getAppearanceColor = (
  theme: DefaultTheme,
  appearance: 'primary' | 'secondary' | undefined
) => {
  return appearance === 'primary'
    ? theme.palette.primary.background
    : theme.palette.secondary.background;
};

export const Box = styled.a<{
  $isActive?: boolean;
  $appearance?: 'primary' | 'secondary';
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 14px;
  background-color: ${({ theme, $appearance }) =>
    getAppearanceColor(theme, $appearance)};
  border: ${({ theme, $appearance }) =>
    `1px solid ${getAppearanceColor(theme, $appearance)}`};
  padding: 10px 10px 10px 15px;

  ${({ $isActive }) =>
    $isActive &&
    css`
      border-color: ${({ theme }) => theme.palette.brand.main};
      background-color: ${({ theme }) => theme.palette.tertiary.background};
    `}

  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.system.blue};
  }
`;

export const Texts = styled.div<{ $isBoxLabelPresented?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: ${({ $isBoxLabelPresented }) =>
    $isBoxLabelPresented ? '22px' : '0'};
`;

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Icons = styled.div`
  display: flex;
`;

export const Description = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  font-size: 10px;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Actions = styled.div`
  display: grid;
  gap: 3.5px;
  align-self: center;
  grid-column: 2/3;
  grid-row: 1/3;
`;

export const Label = styled(Typography.Caption).attrs(() => ({
  $variant: '3',
}))`
  color: ${({ theme }) => theme.palette.brand.main};
  text-align: center;
`;

export const PrevPrice = styled(Typography.Caption).attrs(() => ({
  $variant: '3',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: center;
  position: relative;
  max-width: fit-content;
  justify-self: center;
  white-space: nowrap;
  font-weight: 500;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;
    transform: rotate(-10deg);
    width: 100%;
    height: 1.2px;
    background-color: ${({ theme }) => theme.palette.system.red};
  }
`;

export const PrevPriceAlt = styled(Typography.Caption).attrs(() => ({
  $variant: '3',
}))`
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;
  text-decoration: line-through;
  max-width: fit-content;
  justify-self: center;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
`;

export const Action = styled(Button)`
  border-radius: 20px;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.palette.system.blue};
`;

export const BoxLabel = styled(Typography.Caption)<{
  $isVipBg?: boolean;
  $isPremiumBg?: boolean;
}>`
  position: absolute;
  bottom: -1px;
  left: -1px;
  max-width: fit-content;
  text-transform: uppercase;
  border-radius: 0 7px 0 14px;
  white-space: nowrap;
  padding: 5px 4px;
  font-size: 10px;
  color: ${({ theme }) => theme.palette.primary.background};

  background-color: ${({ theme, $isVipBg, $isPremiumBg }) =>
    $isVipBg
      ? theme.palette.brand.vip1
      : $isPremiumBg
      ? theme.palette.brand.premium1
      : 'transparent'};
`;
